"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyReaction = applyReaction;
exports.default = void 0;
exports.getReactions = getReactions;
exports.getStableId = getStableId;
exports.listenForReactions = listenForReactions;
exports.migrateReactionsToServerMsgid = migrateReactionsToServerMsgid;
exports.store = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _vue = _interopRequireDefault(require("vue"));
// Reactive store: { msgid: { emoji: [nick, ...] } }
// Keyed by server-assigned msgid tag for cross-client consistency.
var store = exports.store = _vue.default.observable({});
/**
 * Get the stable ID for a message.
 * Prefer server-assigned msgid tag; fall back to local id.
 * With echo-message active, every sent message gets a server msgid,
 * so this will be consistent across all connected clients.
 */
function getStableId(message) {
  if (!message) return null;
  if (message.tags && message.tags.msgid) return message.tags.msgid;
  return message.id ? String(message.id) : null;
}
function getReactions(messageId) {
  if (!messageId) return {};
  var normalizedId = String(messageId);
  return store[normalizedId] || {};
}
function applyReaction(messageId, emoji, nick, remove) {
  // Normalize messageId to string for consistency
  var normalizedId = String(messageId);
  if (!normalizedId || !emoji || !nick) {
    return;
  }

  // If we're trying to remove but the message doesn't exist yet, ignore
  if (remove && !store[normalizedId]) {
    return;
  }
  if (!store[normalizedId]) {
    _vue.default.set(store, normalizedId, {});
  }
  if (!store[normalizedId][emoji]) {
    _vue.default.set(store[normalizedId], emoji, []);
  }
  var nicks = store[normalizedId][emoji];
  var idx = nicks.indexOf(nick);
  if (remove && idx > -1) {
    (0, _splice.default)(nicks).call(nicks, idx, 1);
    if (nicks.length === 0) {
      _vue.default.delete(store[normalizedId], emoji);
    }
  } else if (!remove && idx === -1) {
    nicks.push(nick);
  }
  if (store[normalizedId] && (0, _keys.default)(store[normalizedId]).length === 0) {
    _vue.default.delete(store, normalizedId);
  }
}

/**
 * When a message gets its server msgid, migrate any reactions
 * from the local id to the server msgid to maintain consistency.
 * This ensures that reactions applied before the server msgid arrived
 * are available under the correct stable ID.
 */
function migrateReactionsToServerMsgid(localId, serverMsgid) {
  // Normalize both IDs to strings for consistency
  var normalizedLocalId = String(localId);
  var normalizedServerMsgid = String(serverMsgid);
  if (!normalizedLocalId || !normalizedServerMsgid || normalizedLocalId === normalizedServerMsgid) {
    return;
  }
  var localReactions = store[normalizedLocalId];
  if (!localReactions || (0, _keys.default)(localReactions).length === 0) {
    return;
  }

  // If reactions already exist under server msgid, merge them
  if (store[normalizedServerMsgid]) {
    (0, _entries.default)(localReactions).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        emoji = _ref2[0],
        nicks = _ref2[1];
      if (!store[normalizedServerMsgid][emoji]) {
        _vue.default.set(store[normalizedServerMsgid], emoji, []);
      }
      nicks.forEach(function (nick) {
        var _context;
        if (!(0, _includes.default)(_context = store[normalizedServerMsgid][emoji]).call(_context, nick)) {
          store[normalizedServerMsgid][emoji].push(nick);
        }
      });
    });
  } else {
    // Move reactions to server msgid
    _vue.default.set(store, normalizedServerMsgid, localReactions);
  }

  // Remove old local id entry
  _vue.default.delete(store, normalizedLocalId);
}

/**
 * Call once from App.vue mounted() to wire up incoming TAGMSG reactions
 * emitted by IrcClient.js via state.$emit('reaction.update')
 */
function listenForReactions(state) {
  state.$on('reaction.update', function (_ref3) {
    var messageId = _ref3.messageId,
      emoji = _ref3.emoji,
      nick = _ref3.nick,
      remove = _ref3.remove;
    applyReaction(messageId, emoji, nick, remove);
  });
}
var _default = exports.default = {
  store: store,
  getStableId: getStableId,
  getReactions: getReactions,
  applyReaction: applyReaction,
  listenForReactions: listenForReactions,
  migrateReactionsToServerMsgid: migrateReactionsToServerMsgid
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ReactionStore"]
window._kiwi_exports.libs.ReactionStore = exports.default ? exports.default : exports;
